export default __webpack_public_path__ + "static/logo2-96c73d9676e7dfc3c9b38293d1cb53fb.svg";